import React, { useState } from 'react';
import { Eye, Play, CheckCircle2, RefreshCw, BookOpen } from 'lucide-react';

export const SignLanguageModule: React.FC = () => {
  const [selectedSign, setSelectedSign] = useState('namaste');

  const signCards = [
    { id: 'namaste', title: 'Namaste / Greeting', dialect: 'ISL (Indian Sign Language)', videoUrl: 'https://images.unsplash.com/photo-1544717305-2782549b5136?w=600&auto=format&fit=crop&q=80', description: 'Palms pressed together near chest level.' },
    { id: 'thank_you', title: 'Thank You', dialect: 'ISL / ASL Universal', videoUrl: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600&auto=format&fit=crop&q=80', description: 'Touch fingers to chin, move hand forward towards the listener.' },
    { id: 'help', title: 'Need Help', dialect: 'ISL / ASL Universal', videoUrl: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=600&auto=format&fit=crop&q=80', description: 'Thumbs-up hand placed on flat palm moving upwards.' },
  ];

  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm space-y-6">
      <div className="flex items-center justify-between border-b border-slate-100 pb-4">
        <div>
          <span className="px-2.5 py-0.5 bg-indigo-100 text-indigo-800 text-[10px] font-bold rounded-full uppercase tracking-wider">
            SignAll & ASL Benchmark
          </span>
          <h2 className="text-2xl font-bold text-slate-900 mt-1">Sign Language & Gesture Recognition</h2>
          <p className="text-xs text-slate-500">ISL & ASL gesture flashcard engine and fingerspelling dictionary</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Flashcard List */}
        <div className="space-y-3">
          <h3 className="text-xs font-bold text-slate-500 uppercase tracking-wider">ISL / ASL Sign Dictionary</h3>
          {signCards.map((card) => (
            <div
              key={card.id}
              onClick={() => setSelectedSign(card.id)}
              className={`p-3.5 rounded-xl border cursor-pointer transition ${
                selectedSign === card.id 
                  ? 'border-indigo-500 bg-indigo-50/50 shadow-sm' 
                  : 'border-slate-200 hover:bg-slate-50'
              }`}
            >
              <div className="flex items-center justify-between">
                <span className="text-xs font-bold text-slate-900">{card.title}</span>
                <span className="text-[10px] bg-indigo-100 text-indigo-800 px-2 py-0.5 rounded font-bold">
                  {card.dialect}
                </span>
              </div>
              <p className="text-xs text-slate-600 mt-1">{card.description}</p>
            </div>
          ))}
        </div>

        {/* Video Gesture Player */}
        <div className="md:col-span-2 bg-slate-900 text-white rounded-xl p-6 flex flex-col justify-between space-y-4">
          <div className="flex items-center justify-between">
            <span className="text-xs font-bold text-indigo-400 flex items-center gap-1.5">
              <Eye className="w-4 h-4" />
              Live Gesture Video Player
            </span>
            <span className="text-xs text-slate-400">AI Gesture Model: Active</span>
          </div>

          <div className="h-64 bg-slate-950 rounded-lg overflow-hidden relative flex items-center justify-center border border-slate-800">
            <img 
              src={signCards.find(c => c.id === selectedSign)?.videoUrl} 
              alt="Sign gesture" 
              className="w-full h-full object-cover opacity-80"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-transparent to-transparent flex items-end p-4">
              <div>
                <h4 className="text-lg font-bold text-white">
                  {signCards.find(c => c.id === selectedSign)?.title}
                </h4>
                <p className="text-xs text-slate-300">
                  {signCards.find(c => c.id === selectedSign)?.description}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
